// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))

import { Dropdown, Modal, Tabs, Slideover } from "tailwindcss-stimulus-components"
application.register('dropdown', Dropdown)
application.register('modal', Modal)
application.register('tabs', Tabs)
application.register('slideover', Slideover)

import Flatpickr from 'stimulus-flatpickr'
application.register('flatpickr', Flatpickr)


import Audio from 'stimulus-audio'
application.register('audio', Audio)


import StimulusReflex from 'stimulus_reflex'
import consumer from '../channels/consumer'
import controller from './application_controller'
// import printers from './printers_controller'

// Initialize StimulusReflex - check if not already initialized
if (typeof StimulusReflex.initialize === 'function') {
  try {
    StimulusReflex.initialize(application, { consumer, controller, debug: false })
  } catch (error) {
    console.warn('StimulusReflex initialization error (will retry on page reload):', error)
  }
}
